module.exports = __webpack_public_path__ + "img/8d5daf2f8d58cd94d3ff555aa9c6aa64.png";